import { LogoClass } from '../../components/descope-logo/LogoClass';

const vars = LogoClass.cssVarList;

const logo = {
  [vars.fallbackUrl]: 'url(https://imgs.descope.com/components/no-logo-placeholder.svg)',
};

export default logo;
export { vars };
